import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer3 from '../components/Footer3';
import Header3 from '../components/Header3';
import PageBanner from '../components/PageBanner';
import PortfolioDetails from '../components/PortfolioDetails';

function ProjectDetails() {
    return (
        <>
            <Header3 />
            <PageBanner
                bannerBg={bannerBg}
                heading="Portfolio Details"
                currentPage="Portfolio Details"
            />
            <PortfolioDetails />
            <Footer3 />
        </>
    );
}

export default ProjectDetails;
